module.exports = __webpack_public_path__ + "static/media/yuan-wang.41823770.png";